export const getTestRunStatusFromAPI = ( testData ) => {
    return {
        type: "GET_TESTRUNSTATUS_FROM_API",
        testData: testData.data,
        pages: testData.pages,
        currentPage: testData.current_page
    }
}